var Menu = function() {
    var currentScrollTop = 0;
    var self = this;
    var $dropdown = $('.navbar-dropdown');
    var $dropdownSub = $('.navbar-dropdown-subsub');

	this.openTimeout = false;
	this.closeTimeout = false;

    $(function() {
        var scrollBarWidth = getScrollbarWidth();


        // Collapse menu
        /*
        $('.navbar-custom-collapse').on('show.bs.collapse', function(e) {
            $('.navbar-search').collapse('hide');
            $('.navbar-toggle').addClass('active');

            // Het menu kan hoger zijn dan het scherm. In dat geval de huidige
            // scrolltop opslaan en de body overflow hidden geven.
            self.setScrollTop();
            setTimeout(function() {
                $('body').addClass('scroll-disabled');
                $('.navbar-fixed-top').css('margin-right', scrollBarWidth);
            }, 200);
        });

        $('.navbar-custom-collapse').on('hide.bs.collapse', function(e) {
            $('.navbar-toggle').removeClass('active');

            // Bij het sluiten van het menu de body weer overflow scroll geven
            // en de opgeslagen scrolltop laden.
            $('body').removeClass('scroll-disabled');
            $('.navbar-fixed-top').css('margin-right', 0);
            window.scrollTop = currentScrollTop;
        });
        */
        $('.navbar-custom-collapse-mobile').on('show.bs.collapse', function(e) {
            $('.navbar-search').collapse('hide');

            // Het menu kan hoger zijn dan het scherm. In dat geval de huidige
            // scrolltop opslaan en de body overflow hidden geven.
            self.setScrollTop();
            setTimeout(function() {
                $('body').addClass('scroll-disabled');
                $('.navbar-fixed-top').css('margin-right', scrollBarWidth);
            }, 200);
        });

        $('.navbar-custom-collapse-mobile').on('hide.bs.collapse', function(e) {
            $('.navbar-toggle').removeClass('active');

            // Bij het sluiten van het menu de body weer overflow scroll geven
            // en de opgeslagen scrolltop laden.
            $('body').removeClass('scroll-disabled');
            $('.navbar-fixed-top').css('margin-right', 0);
            window.scrollTop = currentScrollTop;
        });


        // Collapse search
        $('.navbar-search').on('show.bs.collapse', function() {
            $('.navbar-custom-collapse').collapse('hide');
            $('.navbar-search-toggle').addClass('active');

            setTimeout(function() {
                $('.navbar-search .form-control').focus();
            }, 400);
        });

        $('.navbar-search').on('hide.bs.collapse', function() {
            $('.navbar-search-toggle').removeClass('active');
            $('body').removeClass('scroll-disabled');
            window.scrollTop = currentScrollTop;
        });


        /*** Logged-in menu ***/

        $('.logged-in-menu-toggle, .logged-in-menu').on('mouseover touchstart', function(e) {
			self.openLoggedInMenu();
			e.stopPropagation();
        });

        $('.logged-in-menu-toggle').on('click', function(e) {
        	e.preventDefault();
        	e.stopPropagation();
		});

		$(document).on('click mouseover touchstart', function() {
			self.closeLoggedInMenu();
		});



        /*** Werking dropdown menu's DESKTOP ***/

        // 1. Sluit het dropdown menu wanneer je niet over een dropdown menu element ga
        $(document).on('mouseover',function(){

            // controleer of submenu open, zo ja uitvoeren
            if ($dropdown.css('height') != '0px') {
                self.closeTimeout = setTimeout(function() {
                    self.closeDropdown();
                    self.closeDropdownSub();
                }, 400);
            }
        });

        // 2. Hoofdmenu items mouseover - toon submenu
        $('.nav-main a').on('mouseover',function(){
            var itemId = $(this).data('id');

            self.openDropdown(itemId);
        });

        // 3. Voorkom dat het submenu wordt gesloten wanneer je over de volgende elementen ga
        $('.nav-main a, .submenu, .subsubmenu-wrapper').on('mouseover',function(e){
            clearTimeout(self.closeTimeout);

            e.stopPropagation();
        });

        // 4. Toon het Subsubmenu wanneer deze aanwezig is
        $('.submenu a').on('mouseover',function() {
        	var itemSubId = $(this).data('id');

			$('.submenu a').removeClass('hover');
			$(this).addClass('hover');

			self.closeDropdownSub();

			if ($(this).hasClass('has-subsubs')) {
                self.openDropdownSub(itemSubId);
            }
        });

        // x. Bij het scrollen dan submenu sluiten, anders opmaak bug
        //$(document).scroll(function() {
		$(document).on('scroll', function() {
            self.closeDropdown();
            self.closeDropdownSub();
        });

    });




    //$(document).keyup(function(e) {
	$(document).on('keyup', function(e) {
        if (e.keyCode == 27) {
            $('.navbar-top .icon-button[data-toggle="collapse"].active').trigger('click');
        }
    });

    this.setScrollTop = function() {
        currentScrollTop = window.scrollTop;
    };

    // this.getScrollbarWidth = function() {
    //     var $div = $('<div />').css({
    //         width: '100px',
    //         height: '100px',
    //         overflow: 'scroll',
    //         position: 'absolute',
    //         top: '-9999px',
    //     }).appendTo($('body'));
	//
    //     var scrollbarWidth = $div.get(0).offsetWidth - $div.get(0).clientWidth;
    //     $div.remove();
	//
    //     return scrollbarWidth;
    // };


	this.openLoggedInMenu = function() {
		$('.logged-in-menu').addClass('active').addClass('opened');
		$('.logged-in-menu ul').stop(false, false).slideDown(200);
	};

	this.closeLoggedInMenu = function() {
		$('.logged-in-menu').removeClass('active');
		$('.logged-in-menu ul').stop(false, false).slideUp(200, function() {
			$('.logged-in-menu').removeClass('opened');
			$(this).removeAttr('style');
		});
	};

    // toon dropdown submenu DESKTOP
    this.openDropdown = function(menuId) {
        var $submenu = $('.submenu[data-id=' + menuId + ']');
        var $menuItem = $('.nav-main a[data-id=' + menuId + ']');
        var submenuHeight = 0;
        var offset = $('.nav-main a[data-id=' + menuId + ']').offset();

        // anders blijft de hover main item staan
        $('.nav-main a').removeClass('hover');

        // ook subsub menu sluiten voor als iemand snel van het ene main menu item naar het andere main menu item gaat
        // en hover class van submenu
        $('.submenu a').removeClass('hover');
        this.closeDropdownSub();

        if ($submenu.length > 0) {

            // verplaats de dropdown container naar de juiste positie, gezien het menu niet genest is
            $('.navbar-dropdown-container').css('left',offset['left']+'px');

            //$menuItem.addClass('hover');
            if($('.submenu[data-id=' + menuId + '] li').length > 0) {
            	$menuItem.addClass('hover');
			}

            $('.submenu').removeClass('open');
            $submenu.addClass('open');
            submenuHeight = $submenu.outerHeight();
        }

        $dropdown.css('height', submenuHeight);
    };


    // sluit dropdown submenu
    this.closeDropdown = function() {
        $('.nav-main a').removeClass('hover');
        $dropdown.css('height', 0);
    };


     // toon dropdown subsubmenu DESKTOP
    this.openDropdownSub = function(menuIdSub) {
        var $subsubmenu = $('#subsubmenu-'+menuIdSub);
        var $subsubmenuHtml = $subsubmenu.html();

        var $menuItemSub = $('.submenu a[data-id=' + menuIdSub + ']');
        var subsubmenuHeight = 0;

        var offsetSub = $('.submenu a[data-id=' + menuIdSub + ']').offset();
        //console.log('offsetSub', offsetSub);

        if ($subsubmenu.length > 0) {

            $('.subsubmenu-wrapper').html($subsubmenuHtml);

            $('.navbar-dropdown-subsub').css({'display':'block','position':'absolute','left':'0px','top':'70px'});//bm
            $('.subsubmenu-wrapper').css({'display':'block','position':'absolute','left':'0px','top':'0px'});//bm

            // verplaats de dropdown container naar de juiste positie, gezien het menu niet genest is
			$('.subsubmenu-wrapper').css('left',offsetSub['left']+'px');
            $('.subsubmenu-wrapper').css('top',offsetSub['top']+'px');
            $('.subsubmenu-wrapper').css('display','block');
        }

        $dropdownSub.css('height', subsubmenuHeight);
    };

    // sluit dropdown subsubmenu DESKTOP
    this.closeDropdownSub = function() {
        $('.subsubmenu-wrapper').css('display','none');
    };



    // mobile menu - toon submenu
    $('.navbar-custom-collapse-mobile a.has-subs').on('click',function(e){
        e.preventDefault();

        var currentLevel = $(this).data('level');
        var clickedId    = $(this).data('id');

        switchMenuMobile(currentLevel, clickedId, 'down');

        return false;
    });

    // mobile menu - back arrow
    $('.ul-header .back').on('click',function(e){
        e.preventDefault();

        var currentLevel = $(this).data('current-level');
        var clickedId    = $(this).data('current-parent-id');

        // we moeten de parent hebben van de clickedId
        var parentId     = $('.ul-mobile a[data-id=' + clickedId + ']').data('parent');

        switchMenuMobile(currentLevel, parentId, 'back');

        return false;
    });

    return this;
}();

function switchMenuMobile(currentLevel, clickedId, moveDirection) {
    newPosition     = 0;
    newCurrentLevel = 0;

    if (moveDirection == 'back') { // backbutton

        if (currentLevel == '2') {

            newPosition     = '0px';
            newCurrentLevel = '1';

        } else if (currentLevel == '3') {

            newPosition     = '-400px';
            newCurrentLevel = '2';
        }

    } else {

        if (currentLevel == '1') {

            // verberg eerst alle menu items om vervolgens van alleen de parent de items te laten zien
            $('#level-2 a').hide();
            $('#level-2 a[data-parent=' + clickedId + ']').show();

            newPosition     = '-400px';
            newCurrentLevel = '2';

        } else if (currentLevel == '2') {

            // verberg eerst alle menu items om vervolgens van alleen de parent de items te laten zien
            $('#level-3 a').hide();
            $('#level-3 a[data-parent=' + clickedId + ']').show();

            newPosition     = '-800px';
            newCurrentLevel = '3';

        }
    }


    // update de 'back' button voor huidige status
    $('.ul-header .back').data('current-level',newCurrentLevel);
    $('.ul-header .back').data('current-parent-id',clickedId);

    // op level 1 niet tonen van back button, op andere niveaus wel + UPDATEN titel + url
    if (newCurrentLevel == '1') {
        $('.ul-header .back').hide();
        $('.ul-header .main-link').text('Menu');
        $('.ul-header .main-link').attr('href','#');
    } else {
        $('.ul-header .back').show();

        var currentTitle = $('.ul-mobile a[data-id=' + clickedId + ']').text();
        var currentUrl   = $('.ul-mobile a[data-id=' + clickedId + ']').attr('href')

        $('.ul-header .main-link').text(currentTitle);
        $('.ul-header .main-link').attr('href',currentUrl)
    }


    // verplaats alle menu's naar links of rechts
    $('#level-1').css('transform','translateX('+newPosition+')');
    $('#level-2').css('transform','translateX('+newPosition+')');
    $('#level-3').css('transform','translateX('+newPosition+')');

    return;
}
